<app-block-animation-config [setAnimationMode]="isAnimationSliceExist" (update)="onAnimationUpdate($event)"></app-block-animation-config>

<mat-accordion [multi]="false">
    <!-- <mat-expansion-panel portalHandler #configPanel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>tune</mat-icon>
                <span class="accordionIcons">configuration</span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>

            @if (configPanel.expanded) {
                <app-video-link style="position: absolute; right: 40px; top: 15px" videoLink="animation"></app-video-link>
            }
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-block-animation-config [showAnimationEngine]="isAnimationSliceExist"></app-block-animation-config>
        </ng-template>
    </mat-expansion-panel> -->

    @if (isAnimationSliceExist) {
        @for (_mode of animationModes; track _mode) {
            <mat-expansion-panel #animationPanel portalHandler [disabled]="!panelStatus[_mode.name]" class="{{_mode.name}}_animation_panel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-checkbox 
                            [checked]="panelStatus[_mode.name]"
                            (change)="toggleAnimation($event.checked, _mode.name, animationPanel)">
                        </mat-checkbox>
                        <span class="panel-label">{{ _mode.translator | transloco }}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <app-block-animation-details [mode]="_mode.name"></app-block-animation-details>
                </ng-template>
            </mat-expansion-panel>
        }
    }
    
</mat-accordion>

